import moment from "moment"
import { FC, Fragment, useState } from "react"
import { Collapse, Modal, ModalBody, ModalHeader } from "reactstrap"
import { InvoiceEmailingDetailModalProps } from "../../interfaces"
import { InvoiceEmailHistory } from "../../Pages/interseller/steps/interfaceSteps"
import NoDataFound from "../layout/NoDataFound"
import TableComponent from "../layout/TableComponent"

const InvoiceEmailingDetailModal: FC<InvoiceEmailingDetailModalProps> = ({ isOpen, emailHistory, toggle }) => {

  const [openRows, setOpenRows] = useState<Record<number, boolean>>({})

  const toggleRow = (index: number) =>
    setOpenRows((prev) => ({ ...prev, [index]: !prev[index] }))

  return (
    <Modal isOpen={isOpen} toggle={toggle} scrollable
      className="for-modal-styling editPlacementDialog">
      <ModalHeader>
        Invoice Emailing Details
      </ModalHeader>
      <ModalBody className="pb-5">
        <div style={{ height: 400, overflowY: 'auto' }}>
          <TableComponent tableHeader={["EmailType", "EmailTo", "Date", "Time"]}>
            <tbody>
              {!emailHistory?.length ? (
                <tr>
                  <td colSpan={4} className="empty-table-td">
                    <NoDataFound text="No Invoice Emailing Details Found!" />
                  </td>
                </tr>
              ) : (
                emailHistory?.map(
                  ({ createdAt, emailType, emailTo, ccTo, bccTo, bodyContent }: InvoiceEmailHistory, index: number) => (
                    <Fragment key={index}>
                      <tr style={{ cursor: "pointer" }} onClick={() => toggleRow(index)}>
                        <td>{emailType}</td>
                        <td>{emailTo || "--"}</td>
                        <td>{moment(Number(createdAt)).format('MM/DD/YYYY')}</td>
                        <td>{moment(Number(createdAt)).format('hh:mm A')}</td>
                      </tr>
                      <tr>
                        <td colSpan={4} className="invoice-email-collapse-td">
                          <Collapse isOpen={!!openRows[index]}>
                            <div className="p-3" style={{ background: "rgba(0,0,0,0.02)" }}>
                              <div className="mb-1"><strong>TO:</strong> {emailTo || "--"}</div>
                              {ccTo && <div className="mb-1"><strong>CC:</strong> {ccTo}</div>}
                              {bccTo && <div className="mb-1"><strong>BCC:</strong> {bccTo}</div>}
                              <div className="mt-2" dangerouslySetInnerHTML={{ __html: bodyContent || "" }} />
                            </div>
                          </Collapse>
                        </td>
                      </tr>
                    </Fragment>
                  )
                )
              )}
            </tbody>
          </TableComponent>
        </div>
      </ModalBody>
    </Modal >
  )
}
export default InvoiceEmailingDetailModal
